<template>
  <div v-scroll="onScroll">
    <div id="trak2" class="d-none"></div>

    <!-- TABS - Only Live Stream -->
    <v-row
      no-gutters
      v-if="$permissions().theSportsLiveStream && $route.query.liveEvent"
      :class="$vuetify.breakpoint.mobile ? 'my-2' : 'mb-2'"
    >
      <v-col cols="6">
        <div class="mr-1">
          <v-btn
            :color="showWidgetLiveStream ? 'primary' : ''"
            block
            @click="showWidgetLiveStream = true"
            :disabled="disabledWidgetLiveStream"
          >
            <v-icon>mdi-youtube-tv</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="6">
        <div class="ml-1">
          <v-btn
            :color="!showWidgetLiveStream ? 'primary' : ''"
            block
            @click="showWidgetLiveStream = false"
          >
            <v-icon>mdi-soccer-field</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-card class="colorDominant">
      <v-progress-linear
        absolute
        v-show="loading"
        indeterminate
      ></v-progress-linear>

      <v-card tile class="pa-0 transparent" elevation="0">
        <!-- IFRAME LIVE STREAM -->
        <div v-show="showWidgetLiveStream && $store.state.logged.status">
          <div id="wrapIframeLiveStream"></div>
        </div>

        <!-- IFRAME - APENAS PARA PLATAFORMA E USUÁRIO LOGADO -->
        <div
          v-show="showWidgetLiveStream && !$store.state.logged.status"
          class="pa-10 text-center"
        >
          <div>
            <div>
              <v-icon size="60">mdi-alert-circle</v-icon>
            </div>
            <div class="py-5">
              {{ $t("unauthorizedLiveStream") }}
            </div>
            <div>
              <DialogRegister />
              <Login />
            </div>
          </div>
        </div>

        <div v-show="!showWidgetLiveStream">
          <!-- WIDGET STATSCORE (CAMPINHO) -->
          <div
            v-show="$permissions().statsCore && !disabledWidgetStatscore"
            id="trak"
            style="min-height: 5px; border-bottom: 1px solid rgba(0, 0, 0, 0.5)"
          ></div>

          <!-- DEFAULT STATIC SCORE SGA -->
          <div v-if="!$permissions().statsCore || disabledWidgetStatscore">
            <v-img
              max-height="250"
              :src="srcImg"
              gradient="rgba(0,0,0,0.5), rgba(0,0,0,0.7)"
              :position="position"
            >
              <v-progress-linear
                v-if="
                  $route.query.liveEvent == true ||
                    $route.query.liveEvent == 'true'
                "
                color="accent"
                buffer-value="0"
                background-opacity="0.9"
                height="3"
                :value="timer ? timer.slice(0, -1) : '100'"
                absolute
                stream
                style="bottom: 0"
              ></v-progress-linear>
              <div
                align="center"
                class="
                  white--text
                  d-flex
                  fill-height
                  justify-space-between
                  align-center
                  subtitle-2
                "
              >
                <!-- Team 1 -->
                <div
                  class="d-flex flex-column align-center"
                  style="flex-basis: 45%"
                  :style="{
                    'margin-left': $vuetify.breakpoint.smAndDown
                      ? '4px'
                      : '10%',
                  }"
                >
                  <TeamLogo
                    :id_sport="data_events.event.id_sport"
                    :id_team="data_events.event.id_team_1"
                    :type_size="'large_logo'"
                    :size="'48px'"
                  />
                  <div
                    class="text-center mt-1 accent--text"
                    :style="{
                      'max-width': $vuetify.breakpoint.xsOnly
                        ? '110px'
                        : '200px',
                    }"
                  >
                    {{ data_events.event.description | format1 }}
                  </div>
                </div>

                <!-- Status (data, placar, etc) -->
                <div
                  class="d-flex flex-column flex-nowrap text-center designStats"
                  style="flex-basis: 10%"
                  :style="{
                    'min-width': $vuetify.breakpoint.smAndDown
                      ? '80px'
                      : '100px',
                  }"
                >
                  <!-- No Live - date and hour -->
                  <div
                    v-if="
                      $route.query.liveEvent == false ||
                        $route.query.liveEvent == 'false'
                    "
                    class="caption"
                  >
                    <div class="font-weight-bold text-uppercase">
                      {{ formatDate(data_events.event.scheduled) }}
                    </div>
                    <div>{{ formatHour(data_events.event.scheduled) }}</div>
                  </div>

                  <!-- Live Score and Time -->
                  <div v-else>
                    <div v-if="scoreSet">
                      <!-- Scores -->
                      <div class="d-flex justify-space-between align-center">
                        <div class="display-1 accent--text">{{ home }}</div>
                        <v-icon size="10">mdi-close</v-icon>
                        <div class="display-1 accent--text">{{ away }}</div>
                      </div>
                      <!-- Tempo -->
                      <div>
                        <div>
                          <span class="live-ani pr-1" v-if="timer">
                            {{ timer }}
                          </span>
                          <span class="caption nowrap">{{ legend }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <v-progress-circular
                        indeterminate
                        size="24"
                        width="2"
                        color="accent"
                      ></v-progress-circular>
                    </div>
                  </div>
                </div>

                <!-- Team 2 -->
                <div
                  class="
                    d-flex
                    flex-column
                    align-center
                    justify-end
                    designComp2
                  "
                  style="flex-basis: 45%"
                  :style="{
                    'margin-right': $vuetify.breakpoint.smAndDown
                      ? '4px'
                      : '10%',
                  }"
                >
                  <TeamLogo
                    :id_sport="data_events.event.id_sport"
                    :id_team="data_events.event.id_team_2"
                    :type_size="'large_logo'"
                    :size="'48px'"
                  />
                  <div
                    class="text-center mt-1 accent--text"
                    :style="{
                      'max-width': $vuetify.breakpoint.xsOnly
                        ? '110px'
                        : '200px',
                    }"
                  >
                    {{ data_events.event.description | format2 }}
                  </div>
                </div>
              </div>
            </v-img>
          </div>
        </div>

        <v-tabs
          v-model="tabsIndex"
          center-active
          :class="{
            'px-0': $vuetify.breakpoint.smAndUp,
          }"
          show-arrows
          background-color="colorDominant colorTabs"
        >
          <!-- Tabs Favorites -->
          <v-tab
            v-if="favoriteMarkets.length > 0"
            dense
            @click="tab = 'favoriteMarkets'"
            class="white--text text-capitalize"
            ><v-icon size="16"> mdi-star </v-icon></v-tab
          >
          <!-- Tabs For -->
          <v-tab
            dense
            v-for="(item, i) in tabs"
            :key="i"
            @click="tab = item"
            class="white--text text-capitalize"
            >{{ item }}</v-tab
          >
        </v-tabs>
      </v-card>
      <!-- <hr class="v-divider theme--dark" /> -->

      <v-card-text class="pa-0">
        <!-- <v-alert text dense type="warning" border="left" class="ma-4 mb-2">Nenhum mercado encontrado!</v-alert> -->
        <!-- <pre>{{ idsMarketsEvent }}</pre> -->
        <div v-for="(id, i) in idsMarketsEvent" :key="i">
          <template v-for="(market, a) in data_events.odds.markets">
            <!-- <pre>{{ market.odds }}</pre> -->
            <!-- aki -->
            <div :key="a" v-if="id == market.id_market">
              <div
                class="py-3 align-center px-4 d-flex"
                style="background: rgba(0, 0, 0, 0.25)"
                :v-if="market.hide_market"
              >
                <div class="subtitle-2 text--secondary text-truncate">
                  {{ getNameMarket(market) }}
                </div>
                <div class="flex-grow-1"></div>

                <div
                  v-if="
                    market.odds.filter(
                      (odd) =>
                        odd.id_market == '1' &&
                        odd.super_odds == '1' &&
                        odd.active == '1'
                    ).length > 0
                  "
                  class="mx-auto"
                >
                  <ArrowHorizontal />
                </div>

                <v-btn
                  x-small
                  fab
                  depressed
                  class="ma-0 transparent ml-2"
                  @click="setFavMarket(market.id_market)"
                >
                  <v-icon
                    :color="
                      favoriteMarkets.some(
                        (item) => item.id_market == market.id_market
                      )
                        ? 'yellow'
                        : 'grey'
                    "
                    size="16"
                  >
                    mdi-star
                  </v-icon>
                </v-btn>
              </div>

              <div
                :class="
                  'd-flex flex-wrap justify-space-between ' + styleFormatOdd
                "
              >
                <div
                  v-for="odd in market.odds"
                  :key="odd.id_odd"
                  :v-if="odd.hide_odd"
                  class="flex-grow-1"
                  style="margin-bottom: 1px"
                  :style="styleFormatOdd == 'flex-row' ? 'width: 30%;' : ''"
                >
                  <div
                    class="
                      pa-3
                      odd odd-live
                      d-flex
                      justify-space-between
                      fill-height
                      subtitle-2
                      align-self-stretch
                    "
                    :class="[
                      odd.blocked
                        ? 'grey--text v-card--disabled'
                        : 'cursor-pointer oddActive white--text',
                      {
                        colorOddSelectedTheme: coupons.some(
                          (item) => item.id_odd == odd.id_odd
                        ),
                        odd_increased: odd.classAni == 'odd_increased',
                        odd_decreased: odd.classAni == 'odd_decreased',
                      },
                    ]"
                    v-on:click="
                      $selectOdd({
                        id_event: data_events.event.id_match,
                        id_odd: odd.id_odd,
                        description: $route.query.event,
                        data: odd,
                      })
                    "
                  >
                    <div class="caption">{{ odd.name_odd }}</div>
                    <div>
                      <v-icon class="px-2" v-if="odd.blocked" size="14">
                        mdi-lock
                      </v-icon>
                      <div
                        v-else
                        class="pl-2 colorOddText--text"
                        :ref="odd.id_odd"
                        :class="odd.id_odd"
                      >
                        {{ Number(odd.odd_price).toFixed(2) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </v-card-text>
    </v-card>

    <!-- MINI APP BAR -->
    <template
      v-if="
        !$permissions().statsCore ||
          ($permissions().statsCore &&
            ($route.query.liveEvent == false ||
              $route.query.liveEvent == 'false'))
      "
    >
      <v-toolbar
        v-if="$vuetify.breakpoint.mobile"
        elevation="10"
        class="colorDominant caption miniAppbar"
        :class="miniAppbarAni ? 'miniAppbarAni' : 'miniAppbarAniClose'"
      >
        <div style="width: 40%">
          <div class="d-flex align-center">
            <TeamLogo
              :id_sport="data_events.event.id_sport"
              :id_team="data_events.event.id_team_1"
              :type_size="'medium_logo'"
              :size="'40px'"
            />
            <div class="text-truncate caption pl-1" style="max-width: 80px">
              {{ data_events.event.description | format1 }}
            </div>
          </div>
        </div>
        <div style="width: 20%">
          <div
            v-if="
              $route.query.liveEvent == false ||
                $route.query.liveEvent == 'false'
            "
            class="caption"
          >
            <div class="d-flex flex-column caption text-center">
              <div class="font-weight-bold text-uppercase">
                {{ formatDate(data_events.event.scheduled) }}
              </div>
              <div>{{ formatHour(data_events.event.scheduled) }}</div>
            </div>
          </div>
          <!-- Live Score and Time -->
          <div v-else>
            <div v-if="scoreSet">
              <!-- Scores -->
              <div class="d-flex justify-space-between align-center">
                <div class="display-1 accent--text">{{ home }}</div>
                <div class="caption live-ani" size="10" v-if="timer">
                  {{ timer }}
                </div>
                <div class="display-1 accent--text">{{ away }}</div>
              </div>
            </div>
            <div v-else class="text-center">
              <v-progress-circular
                indeterminate
                size="24"
                width="2"
                color="accent"
              ></v-progress-circular>
            </div>
          </div>
        </div>
        <div style="width: 40%">
          <div class="d-flex align-center justify-end">
            <div class="text-truncate caption" style="max-width: 80px">
              {{ data_events.event.description | format2 }}
            </div>
            <TeamLogo
              :id_sport="data_events.event.id_sport"
              :id_team="data_events.event.id_team_2"
              :type_size="'medium_logo'"
              :size="'40px'"
            />
          </div>
        </div>
      </v-toolbar>
    </template>
  </div>
</template>
<!-- <script rel="script" src="https://live.statscore.com/livescorepro/generator?auto_init=false"></script> -->
<script>
import websocket from "@/mixins/websocket";
import statscore from "@/mixins/statscore";
import scores from "./scores";
import { mapState } from "vuex";
import TeamLogo from "@/components/team-logo";
import ArrowHorizontal from "@/assets/ArrowHorizontal";

export default {
  name: "sports",
  mixins: [websocket, scores, statscore],
  components: {
    TeamLogo,
    ArrowHorizontal,
  },
  data: function() {
    return {
      data_events: {
        event: {
          description: " X ",
          // scheduled: '1960-01-01 00:00:00'
        },
        odds: {
          markets: "",
        },
      },
      data_events_live: [],
      // prices: [],
      // animate: [],
      loading: false,
      tab: "todos",
      tabsIndex: null,
      // tabs: '',
      oddFirst: "",
      classAni: "",
      srcImg: "",
      position: "center bottom",
      status: null, // tratamento para erro 400

      miniAppbarAni: false,
    };
  },
  // beforeDestroy(){},
  async beforeRouteLeave(to, from, next) {
    // Antes de ir para outra rota ele vai executar abaixo:
    if (this.$route.query.liveEvent === "true" && this.status != 400) {
      this.connection.onclose();
      next();
    } else {
      next();
    }
  },
  computed: mapState({
    // recupera status login
    // logged: function () {
    //   return this.$store.state.logged.status;
    // },
    // recupera odd mínima do operador
    // oddMin: function() {
    //   return this.$store.state.operators.odd_min;
    // },
    // recupera o Bilhete
    coupons() {
      return this.$store.getters.getCoupons;
    },
    // recupera o id do operador em tipo number.
    idOperator: function() {
      return Number(this.$store.state.operators.operator_id);
    },
    // recupera o id do esporte em destaque
    idSport: function() {
      return this.$store.getters.getIdSportByName(this.$route.query.sport);
    },
    // recupera um array de id markets com base na tab selecionada.
    idsMarketsEvent: function() {
      return this.$store.getters.getIdMarketsEventByTab(this.tab);
    },
    // recupera um array de tabs
    tabs: function() {
      const markets = this.data_events.odds.markets;
      const stateMarkets = this.$store.state.markets; // (é onde estão as tabs.)
      let idSprt = this.idSport;
      const items = [];
      // tratamento das tabs
      function filterTab(item) {
        // recupera o primeiro item encontrado com o mesmo valor de id
        const market = stateMarkets.find((i) => i.id_market == item.id_market);

        // armazena a tab
        if (market == undefined) return;
        let tab = market.tab || "";
        // trata o nome da tab para outros esportes
        if (idSprt == 54094 && tab == "gols") tab = "sets";
        if (idSprt == 48242 && tab == "gols") tab = "pontos";
        if (idSprt == 687890 && tab == "gols") tab = "rodadas";
        if (idSprt == 265917 && tab == "gols") tab = "pontos";
        if (idSprt == 154914 && tab == "gols") tab = "pontos";

        // insere a tab no array items
        items.push(tab);
      }
      // inicia aqui
      if (markets != "" && idSprt != undefined) {
        markets.filter(filterTab);
      }
      // Insere todos como a primeira tab
      items.unshift("todos");
      // Convert os valores do array em únicos
      let unique = [...new Set(items)];
      return unique;
    },
    // Recupera os Favoritos
    favoriteMarkets: function() {
      const favorires = this.$store.state.favoriteMarkets;
      return favorires.length > 0 ? favorires : [];
    },
    // Recupera Style Format Odd
    styleFormatOdd: function() {
      return this.$store.state.styleFlexWrapOdds;
    },
  }),
  mounted() {
    this.scoreSet = false;

    //
    // SETUP
    //
    // Tab Setup
    this.tabsIndex = this.favoriteMarkets.length > 0 ? 1 : 0;
    // Preenchendo o Cupom;
    // Recuperando os parametros da rota;
    const { params } = this.$route;

    // Get Data Event
    this.getData(params.event);
    // Get Background Event Sport
    this.bg();
  },
  watch: {
    // Tratando as Odds
    data_events_live: function(odds) {
      if (odds == undefined) return;

      for (const odd of odds) {
        if (this.$refs[odd.id_odd] != undefined) {
          for (const item of this.data_events.odds.markets) {
            for (let item_odd of item.odds) {
              if (odd.id_odd == item_odd.id_odd) {
                // Comparação de Preços de Odds;
                let new_price = `${odd.preco_atual}`;
                let current_price = item_odd.odd_price;
                let active = odd.status;

                // Tratamento
                if (item_odd.odd_price != `${odd.preco_atual}`) {
                  // Animação CSS
                  let increased = new_price > current_price;
                  let decreased = new_price < current_price;
                  if (increased) this.classAni = "odd_increased";
                  if (decreased) this.classAni = "odd_decreased";

                  // Incrementando no (this.data_events.odds.markets)
                  this.$set(item_odd, "odd_price", new_price);
                  this.$set(item_odd, "active", active);
                  this.$set(item_odd, "classAni", this.classAni);

                  // Incrementando desconto novo;
                  // Aqui é alterado o valor de odd_margin
                  // para o valor retornado do websocket em "descontos"
                  if (this.descontos.length > 0) {
                    for (const desconto of this.descontos) {
                      if (desconto.id_tipo_aposta == odd.id_tipo_aposta) {
                        var { margem_banca, margem_evento } = desconto;
                        let odd_margin = `${margem_banca + margem_evento}`;
                        this.$set(item_odd, "odd_margin", odd_margin);
                      }
                    }
                  }

                  item_odd = this.$treatOdd(item_odd);
                }
              }
            }
          }
        }
      }
    },

    // Observa a troca de eventos:
    $route(newRoute, oldRoute) {
      // Live
      if (newRoute.params.event !== oldRoute.params.event) {
        this.scoreSet = false;
        const { params } = this.$route;
        if (this.connection) {
          this.connection.onclose();
          this.getData(params.event);
          this.bg();
        }
      }

      // Pre-match
      if (
        newRoute.path != oldRoute.path &&
        (this.$route.query.liveEvent == false ||
          this.$route.query.liveEvent == "false")
      ) {
        const { params } = this.$route;
        this.getData(params.event);
        this.bg();
      }
    },

    // Reset Favorites Market = 0
    favoriteMarkets(val) {
      if (val.length == 0) {
        this.tabsIndex = 0;
        this.tab = "todos";
      }
    },
  },
  methods: {
    getNameMarket(market) {
      let marketName = market.name_market;
      if (this.idSport == 54094) {
        marketName = marketName.replace("Gols", "Pontos");
      }

      return marketName;
    },
    getData: function(id_event) {
      this.loading = true;
      const obj = { id_event, domain: this.$domain() };
      this.$axios
        .post("/tableMain/event", this.$formdata(obj))
        .then((response) => {
          this.data_events = this.treatMarket(response.data);
          this.data_events.event.live == "1"
            ? this.connect(this.idOperator, id_event, "wss://ws.sga.bet")
            : null;

          this.loading = false;

          return response.data.event;
        })
        .then((event) => {
          // console.log(event);
          // Event view_item Analytics (View Evento);
          this.$gtag.view_item(
            event,
            this.$route.query.category,
            this.$route.query.tournament
          );
        })
        .catch((error) => {
          this.$store.commit("setDialogEvent", false);
          const msg = error.response.data.messages.error;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });

          // Tratamento para eventos não encontrados:
          this.status = error.response.data.status;
          if (this.status == 400) {
            // redireciona para a página de live (se live true):
            if (this.$route.query.liveEvent === "true") {
              this.$router.push({
                name: "live",
                query: { live: this.$route.query.sport },
              });
            } else {
              this.$router.push("/");
            }
          }
        });
    },

    // TRATANDO O GET EVENT (Com os dados do InfoTable)
    // Recuperando o nome do Market e criando uma key (name_market)
    // Recuperando o Status Active do Market e criando uma Key (hide_market)
    // Recuperando o nome da odd e criando uma nova key (name_odd);
    // Recuperando o Status Active da odd e criando uma nova key (hide_odd);
    // Aplicando o Tratamento da ODD;
    treatMarket: function(data) {
      const results = this.$store.getters.getResults;

      // MARKETS
      for (let market of data.odds.markets) {
        // Market = Incluindo Name_market and hide_market
        const markets = this.$store.getters.getMarkets;
        const marketFilter = markets.find(
          (item) => item.id_market == market.id_market
        );
        market.name_market = marketFilter ? marketFilter.name_market : "";
        market.hide_market = marketFilter.active == 0 ? true : false;

        // ODDS
        for (let odd of market.odds) {
          // Odd = Incluindo Name_odd and hide_odd
          const result = results.find(
            (item) => item.id_outcome == odd.id_outcome
          );
          odd.name_odd = result ? result.name_outcome : "";
          odd.hide_odd = result.active == 0 ? true : false;

          // Aplicando a Margem na ODD;
          odd = this.$treatOdd(odd);
        }
      }
      return data;
    },
    bg: function() {
      const sport = this.$route.params.sport;
      const isWorldCup = this.$route.params.tournament == 31004;

      const backBg = {
        6046: "https://dozr8la71aog.cloudfront.net/images/event/soccer.jpg", // futebol
        31004: "https://dozr8la71aog.cloudfront.net/images/event/soccer.jpg", // copa do mundo
        54094: "https://dozr8la71aog.cloudfront.net/images/event/tennis.jpg", // tenis
        154919: "https://dozr8la71aog.cloudfront.net/images/event/fight.jpg", // luta
        48242: "https://dozr8la71aog.cloudfront.net/images/event/basketball.jpg", // basquete
        154914: "https://dozr8la71aog.cloudfront.net/images/event/baseball.jpg", // baseball
        154830: "https://dozr8la71aog.cloudfront.net/images/event/volleyball.jpg", // volleyball
        10: "https://dozr8la71aog.cloudfront.net/images/event/special.jpg", // especiais
        //10: "https://dozr8la71aog.cloudfront.net/images/event/bbb.png", // especiais / bbb
        //10: "https://dozr8la71aog.cloudfront.net/images/event/politica2022.png", // especiais / política 2022
        687890: "https://dozr8la71aog.cloudfront.net/images/event/esports.jpg",
        131506: "https://dozr8la71aog.cloudfront.net/images/event/football.jpg",
        35709: "https://dozr8la71aog.cloudfront.net/images/event/handball.jpeg",
        265917: "https://dozr8la71aog.cloudfront.net/images/event/tabletennis.jpeg",
        621569: "https://dozr8la71aog.cloudfront.net/images/event/beachvolley.jpeg",
        51: "https://dozr8la71aog.cloudfront.net/images/event/libertadores.png",
        52: "https://dozr8la71aog.cloudfront.net/images/event/umpraum.png",
        687887: "https://dozr8la71aog.cloudfront.net/images/event/futsal.png",
        53: "https://dozr8la71aog.cloudfront.net/images/event/futvolei.png",
        54: "https://dozr8la71aog.cloudfront.net/images/event/special.jpg",
      };
      if (sport == 6046) this.position = "center bottom 20%";
      if (isWorldCup) this.position = "center top";
      if (sport == 54094) this.position = "center top 30%";
      if (sport == 48242) this.position = "center center";
      if (sport == 687890) this.position = "center center";
      if (sport == 131506) this.position = "center center";
      if (sport == 35709) this.position = "center center";
      if (sport == 265917) this.position = "center center";
      if (sport == 621569) this.position = "center center";
      if (sport == 10) this.position = "center center";
      if (sport == 51) this.position = "center center";
      if (sport == 52) this.position = "center center";
      if (sport == 687887) this.position = "center bottom 20%";
      if (sport == 53) this.position = "center center";
      if (sport == 54) this.position = "center center";

      this.srcImg = isWorldCup ? backBg[31004] : backBg[sport];
    },
    closeDialogEvent() {
      this.$store.commit("setDialogEvent", false);
    },
    formatDate: (val) => {
      let gmt = new Date();
      gmt.getTimezoneOffset() / 60;
      let sub = String(gmt);
      sub = sub.slice(28, 31);

      if (val != undefined) {
        var dateEvent = new Date(
          `${val.replace(" ", "T")}${sub}:00`
        ).toLocaleDateString();
        var today = new Date().toLocaleDateString();

        let todayTranslate = {
          pt: { today: "Hoje" },
          es: { today: "Hoy" },
          en: { today: "Today" },
        };
        let lang = localStorage.getItem("language");
        if (dateEvent == today) return todayTranslate[lang].today;
        return dateEvent;
      }
    },
    formatHour: (val) => {
      let gmt = new Date();
      gmt.getTimezoneOffset() / 60;
      let sub = String(gmt);
      sub = sub.slice(28, 31);
      if (val != undefined) {
        return new Date(`${val.replace(" ", "T")}${sub}:00`)
          .toLocaleTimeString()
          .slice(0, -3);
      }
    },
    // Set Favorite in Store
    setFavMarket(id_market) {
      var id_sport = this.$route.params.sport;
      // Remove favorite;
      if (this.favoriteMarkets.some((item) => item.id_market == id_market)) {
        this.$store.commit("removeFavoriteMarkets", { id_sport, id_market });
        return;
      }
      // Set Favorite
      this.$store.commit("setFavoriteMarkets", { id_sport, id_market });
    },
    onScroll() {
      if (window.pageYOffset > 410) {
        this.miniAppbarAni = true;
      } else {
        this.miniAppbarAni = false;
      }
    },
  },
  filters: {
    format1: (val) => val.split(" X ")[0].toUpperCase(),
    format2: (val) => val.split(" X ")[1].toUpperCase(),
  },
};
</script>

<style lang="sass" scoped>
// .designComp1
//   border-radius: 4px 0px 0 8px
// .designComp2
//   border-radius: 0 4px 8px 0
// .designComp1, .designComp2
//   padding: 8px
//   min-height: 36px
// .designStats
//   position: relative
//   border-radius: 0 0 8px 8px
//   padding: 10px 8px 10px
//     // border-top: 2px solid var(--v-primary-base)
//   min-height: 60px
// .designComp1, .designComp2, .designStats
//   background: rgba(255,255,255,0.2)
//   -webkit-backdrop-filter: blur(10px)
//   backdrop-filter: blur(10px)
</style>

<style lang="css">
.odd-live {
  border-radius: 0px !important;
  margin: 0px 0 0px 1px;
}
.odd-live.odd_increased::before,
.odd-live.odd_decreased::before,
.odd-live.odd_increased::after,
.odd-live.odd_decreased::after {
  border: 5px solid transparent;
  right: 2px !important;
}
.odd-live.odd_increased::before,
.odd-live.odd_decreased::after {
  bottom: 2px;
}
.odd-live.odd_decreased::before,
.odd-live.odd_increased::after {
  top: 2px;
}
.odd-live.odd_increased::before {
  border-bottom-color: rgba(255, 255, 255, 0.1);
  border-right-color: rgba(255, 255, 255, 0.1);
}
.odd-live.odd_increased::after {
  border-top-color: #76ff03;
  border-right-color: #76ff03;
}
.odd-live.odd_decreased::before {
  border-top-color: rgba(255, 255, 255, 0.1);
  border-right-color: rgba(255, 255, 255, 0.1);
}
.odd-live.odd_decreased::after {
  border-bottom-color: #d32f2f;
  border-right-color: #d32f2f;
}

/* StatsCore */
.styleWidget {
  position: fixed;
  background-color: #303030;
  animation: opacity 300ms ease-in;
  display: block;
  box-shadow: 0 3px 8px rgb(0, 0, 0, 0.2);
  transform: translateY(0);
}
.styleWidgetMobile {
  z-index: 200;
  right: 300px;
  top: 0px;
  right: 0px;
  max-height: 150px;
  width: 250px;
}
.styleWidgetDesktop {
  z-index: 205;
  right: 300px;
  top: 64px;
  max-height: 210px;
  max-width: 400px;
  width: 50%;
}
.notWidget {
  height: 0px;
  animation: 1500ms close 0ms ease-in-out;
}
@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes close {
  0% {
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
/* Mini App Bar */
.miniAppbar {
  z-index: 11;
  position: fixed;
  top: -64px;
  width: 100%;
}
.miniAppbarAni {
  animation: showMiniAppBar 0.2s ease-in;
  top: 0;
}
.miniAppbarAniClose {
  top: -64px;
  animation: closeMiniAppBar 0.2s ease-out;
}

@keyframes showMiniAppBar {
  from {
    top: -64px;
  }
  to {
    top: 0;
  }
}
@keyframes closeMiniAppBar {
  from {
    top: 0;
  }
  to {
    top: -64px;
  }
}
</style>
